import { FC } from 'react';
import Typography from '@/components/UI/typography/Typography';
import Box from '@/components/UI/box/Box';
import styles from './SimilarProducts.module.scss';
import SimilarProductsContainer from './similarProductsContainer/SimilarProductsCountainer';
import Link from 'next/link';
import Button from '@/components/UI/button/Button';
import Divider from '@/components/UI/divider/Divider';
type SimilarProductsProps = {
  bookableStatus: string;
  parentId?: number;
};
const SimilarProducts: FC<SimilarProductsProps> = ({
  bookableStatus,
  parentId
}) => {
  return <>
      <Box data-sentry-element="Box" data-sentry-source-file="SimilarProducts.tsx">
        <Typography variant="bodyL_Bold" color="neutral_800" component="h2" className={`${styles['similar-products']} ${bookableStatus === 'non_bookable' ? styles['similar-products-non-bookable'] : ''} `} data-sentry-element="Typography" data-sentry-source-file="SimilarProducts.tsx">
          {bookableStatus === 'bookable' ? 'اقامتگاه های مشابه' : 'پیشنهاد‌های ما'}
        </Typography>
        <SimilarProductsContainer data-sentry-element="SimilarProductsContainer" data-sentry-source-file="SimilarProducts.tsx" />
      </Box>
      {parentId && <Box className={styles['other-rooms-wrapper']}>
          <Link href={`/search?parent_id=${parentId}`} passHref>
            <Button format="outlined" className={styles['other-rooms-button']}>
              مشاهده دیگر اتاق های این مجموعه بومگردی{' '}
            </Button>
          </Link>
        </Box>}
      <Divider data-sentry-element="Divider" data-sentry-source-file="SimilarProducts.tsx" />
    </>;
};
export default SimilarProducts;